import { useQuery } from 'react-query';

import { getStudioMembersAuth0 } from '@services/queries/studios';

import UpIcon from '@assets/svg/table-up.svg';
import ProfileImg from '@assets/svg/avatar-placeholder.svg';

import { MembersLoading } from './loading/Members.loading';
import { MembersError } from './error/Members.error';

import {
  Container,
  Head,
  Invite,
  Profile,
  Table,
  User,
  MenuDiv,
  Divider,
  Text,
  MenuContainer,
  Span,
  Wrapper,
} from './CurrentUsers.styles';
import { CurrentUsersMenu } from './CurrentUsersMenu/CurrentUsersMenu';

interface ICurrentUsers {
  searchText: string;
}

const CurrentUsers = ({ searchText }: ICurrentUsers) => {
  const { data, isLoading, isError } = useQuery(
    ['membersAuth0', searchText],
    () =>
      getStudioMembersAuth0({
        search: searchText,
      }),
  );

  if (isLoading) {
    return <MembersLoading />;
  }

  if (isError || !data) {
    return <MembersError />;
  }

  return (
    <Container>
      <Table>
        <thead>
          <tr>
            <th>
              <Head className="first-header">Member</Head>
            </th>
            <th>
              <Head>Email</Head>
            </th>
            <th>
              <Head>Invited By</Head>
            </th>
            <th>
              <Head className="role-header">
                <Wrapper>
                  Role
                  <Span>
                    <img src={UpIcon} alt="" />
                  </Span>
                </Wrapper>
              </Head>
            </th>
            <th>
              <Head className="menu-header">
                <MenuDiv>M</MenuDiv>
              </Head>
            </th>
          </tr>
        </thead>

        <tbody>
          {data.map(item => (
            <tr key={item.id}>
              <td>
                <User>
                  {item.picture ? (
                    <Profile
                      src={item.picture || ProfileImg}
                      alt=""
                      blocked={item.blocked}
                    />
                  ) : (
                    <Profile src={ProfileImg} alt="" blocked={item.blocked} />
                  )}

                  <Divider width="8px" />
                  <Text className="currentUser" blocked={item.blocked}>
                    {item.auth0Name || item.name}
                  </Text>
                </User>
              </td>
              <td>
                <Text className="currentUser" blocked={item.blocked}>
                  {item.email}
                </Text>
              </td>
              <td>
                <Invite>{item.userInvite?.user?.name || ''}</Invite>
              </td>
              <td>
                <Text className="currentUser" blocked={item.blocked}>
                  {item.role}
                </Text>
              </td>
              <td>
                <MenuContainer>
                  <CurrentUsersMenu user={item} />
                </MenuContainer>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export { CurrentUsers };
